import React from 'react';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { useTheme } from 'styled-components';
import {
  Container,
  StyledCheckBox,
  StyledCheckBoxLabel,
} from './Checkbox.styles';

export interface CheckboxProps {
  /**
   * If true, the component is checked.
   */
  checked: boolean;
  /**
   * Optional change handler.
   */
  onChange: () => void;
  disabled?: boolean;
  'data-testid'?: string;
  variant?: 'default' | 'indeterminate';
  label?: string;
  labelPosition?: 'right' | 'left';
  labelSize?: 'regular' | 'large';
  $justifyContent?: string;
  $width?: string;
  clickableRow?: boolean;
  $round?: boolean;
  $checkedColor?: string;
  $fullWidthLabel?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  onChange,
  checked,
  disabled,
  label,
  labelPosition = 'left',
  variant = 'default',
  clickableRow = false,
  labelSize = 'regular',
  ...props
}: CheckboxProps) => {
  const theme = useTheme();
  return (
    <Container
      $justifyContent={props.$justifyContent}
      $width={props.$width}
      $clickableRow={clickableRow}
      onClick={() => clickableRow && onChange()}
    >
      {label && labelPosition === 'left' && (
        <StyledCheckBoxLabel
          disabled={disabled}
          title={label}
          labelSize={labelSize}
          $fullWidthLabel={props.$fullWidthLabel}
        >
          {label}
        </StyledCheckBoxLabel>
      )}
      <StyledCheckBox
        onClick={() => !disabled && !clickableRow && onChange()}
        disabled={disabled}
        checked={checked}
        $checkedColor={props.$checkedColor}
        data-testid={props['data-testid']}
        {...props}
      >
        {checked && (
          <StyledIcon
            color={theme.atlas.semantic.color.action.primary.onPrimary}
            className={variant === 'default' ? 'uil-check' : 'uil-minus'}
          />
        )}
      </StyledCheckBox>
      {label && labelPosition === 'right' && (
        <StyledCheckBoxLabel
          disabled={disabled}
          title={label}
          labelSize={labelSize}
          $fullWidthLabel={props.$fullWidthLabel}
        >
          {label}
        </StyledCheckBoxLabel>
      )}
    </Container>
  );
};
